export const getSelectedFiltersFromUrl = (location, filters = []) => {
    if (!location) return
    const searchParams = new URLSearchParams(location.search)
    if (!searchParams) return
    const selectedFilters = {}
    for (const [key, value] of searchParams.entries()) {
        const valuesFound = value
            .split(',')
            .filter((o) =>
                (
                    filters
                        ?.find((f) => f['fieldUID'] === key)
                        ?.options?.map((o) => o.contentstackValue) || []
                ).includes(o),
            )
        if (valuesFound?.length > 0) {
            selectedFilters[key] = valuesFound.map((v) => ({contentstackValue: v}))
        }
    }
    return selectedFilters
}

export const removeFilter = (location, history, filter) => {
    if (!location || !filter) return

    const searchParams = new URLSearchParams(location.search)

    for (const key of searchParams.keys()) {
        const values = searchParams.get(key).split(',')
        const newValues = values.filter((v) => v !== filter.contentstackValue)

        if (newValues.length > 0) {
            searchParams.set(key, newValues.join(','))
        } else {
            searchParams.delete(key)
        }
    }

    history.push({
        pathname: location.pathname,
        search: searchParams.toString(),
    })
}
export const clearAllFilters = (location, history) => {
    if (!location || !history) return
    const searchParams = new URLSearchParams()

    history.push({
        pathname: location.pathname,
        search: searchParams.toString(),
    })
}
